import { Component, EventEmitter, Inject, Input, OnInit, Output } from '@angular/core';
import { ManualAddressDto } from '@shared/src/controllers/maps/ManualAddressDto';
import { ActivatedRoute } from "@angular/router"
import { MatDialog } from '@angular/material/dialog';
import { FileUpDownloadController } from '@shared/src/controllers/fileupdownload/fileupdownload.controller';
import { OpenRouteController } from '@shared/src/controllers/open/open.route.controller';
import { SocketController } from '@shared/src/controllers/socket/socket.controller';
import { ShipmentController } from '@shared/src/controllers/route/shipment/shipment.controller';
import { AlertService, HColor, PhaseController, SharedAsideFactory } from '@shared/src/public-api';
import { SystemController } from '@shared/src/controllers/system/system.controller';
import { PhaseCardItemDto } from '@shared/src/dtos/phase/PhaseCardItemDto';
import { HLong } from '@shared/src/datatypes/HLong';
import { ActionsStripDto } from '@shared/src/dtos/maintenance/action/ActionsStripDto';
import { ActionDto } from '@shared/src/dtos/maintenance/action/actionDto';

@Component({
    selector: 'shared-active-slots-item-phase',
    templateUrl: './shared.active.slots.item.phase.html',
    styleUrls: ['./shared.active.slots.item.phase.scss']
})
export class SharedActiveSlotsItemPhase implements OnInit {

    constructor(protected socketController: SocketController, protected activatedRoute: ActivatedRoute, public dialog: MatDialog, public phaseController: PhaseController,
        public openRouteController: OpenRouteController, public fileUpDownloadController: FileUpDownloadController, public shipmentController: ShipmentController, public systemController: SystemController,
        @Inject('AlertService') public alertService: AlertService,
        @Inject('SharedAsideFactory')
        public sharedAsideFactory: SharedAsideFactory) {
    }

    ngOnInit(): void { }

    public onMarkerClick() {
        if (this.phase != null && !this.exwork)
            this.sharedAsideFactory.invokeAddressCoordinates(ManualAddressDto.buildFromPhase(this.phase));
    }

    @Input()
    public readonly: boolean = false;

    @Input()
    public exwork: boolean = false;

    @Input()    
    public avoidPropertyPendingResponse: boolean = false;

    public __phase: PhaseCardItemDto;
    @Input()
    public set phase(value: PhaseCardItemDto) {
        if (this.__phase == value)
            return;
        this.__phase = value;
        this.wellCome();
        if (value != null)
            this.actions = ActionsStripDto.buildFromActionsStripDto(value.actions);

    }
    public get phase(): PhaseCardItemDto {
        return this.__phase;
    }

    public generalStatusResource: string = "";
    wellCome() {
        if (this.phase != null && this.phase.generalStatus != null)
            this.generalStatusResource = "GENERALSTATUS.ENUM." + this.phase.generalStatus.toUpperCase();
        else
            this.generalStatusResource = "GENERALSTATUS.ENUM.NONE";
    }



    public __intervals: boolean = false;
    @Input()
    public set intervals(value: boolean) {
        if (this.__intervals == value)
            return;

        this.__intervals = value;
    }
    public get intervals(): boolean {
        return this.__intervals;
    }

    getSlots() {
        this.intervals = !this.intervals;
    }

    @Input()
    public hideLink: boolean = false;

    public _autoGetSlots: boolean = false;
    @Input()
    public set autoGetSlots(value: boolean) {
        if (this._autoGetSlots == value)
            return;
        this._autoGetSlots = value;
        if (this._autoGetSlots)
            this.getSlots();
    }
    public get autoGetSlots(): boolean {
        return this._autoGetSlots;
    }

    public actions: ActionsStripDto;


    getSlotPickerResource(): string {
        if (this.phase && !HLong.isNullOrNullLong(this.phase.slotId)) {
            return 'ACTIVESLOTS.SLOTPICKER.OPENCHANGESLOTSBUTTON.CAPTION';
        }
        return 'ACTIVESLOTS.SLOTPICKER.OPENASSIGNSLOTSBUTTON.CAPTION';
    }

    getTextColor(data: HColor) {
        if (data != null)
            return HColor.getWhiteBlackFromColor(data.web);

        return HColor.getWhiteBlackFromColor(HColor.defaultColor().web);
    }

    getBackColor(data: HColor) {
        return HColor.getColorOrDefaultColor(data, HColor.defaultColor().web);
    }


	@Output() public refreshRoute: EventEmitter<any> = new EventEmitter<any>();
	@Output() public phaseDocumentation: EventEmitter<any> = new EventEmitter<any>();
	@Output() public phaseSignatureCMR: EventEmitter<any> = new EventEmitter<any>();

	onDocumentClick() {
		this.phaseDocumentation.next(this.phase.phaseId);
	}

	onPhaseSignatureCMRClick() {
		this.phaseSignatureCMR.next(this.phase);
	}

	onRefreshRoute(event: boolean) {
		if (event)
			this.refreshRoute.next(event);
	}


    onClickAction(action: ActionDto) {
        this.phaseController.executePhaseActions(action, this.phase.phaseId).subscribe(
            d => {
                if (d)
                    this.refreshRoute.next(true);
            }
        );
    }


    public pretty(value: any): string {
        return JSON.stringify(value);
    }

}
